import React, {useEffect, useState} from 'react';

const Card = ({ alias, title, imageUrl, owner, category, alt }) => {
  const [className, setClassName] = useState('');

  useEffect(() =>  {
    if (window.innerWidth >= 1200) {
      setClassName('col--tablet--4');
    } else if (window.innerWidth < 1200 && window.innerWidth >= 900) {
      setClassName('col--tablet--6');
    } else {
      setClassName('col--tablet--12');
    }
  });

  return (
    <div className={className}>
      <div className="card nominees__card">
        <div className="nominees__card__body">
          <div className="nominees__card__image">
            <img alt={alt} src={imageUrl} width="285" height="175" typeof="Image" className="img-responsive"/>
          </div>
          {owner ?
            <div className="nominees__card__owner">
              {owner}
            </div> : null}
          <div className="nominees__card__title">
            <h2>
              <span>
               {title}
              </span>
            </h2>
          </div>
          <div className="nominees__card__url">
            <a href={alias}>Nominees link</a>
          </div>
        </div>
        <div className="nominees__card__footer">
          <div className="nominees__card__footer--nominated">
            Nominated for
          </div>
          <div className="field--name-field-categories">
            {category.map(category => <div className="field--item" key={category}>{category}</div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card;
